module.exports = __webpack_public_path__ + "img/editor-logo.1549fd9e.png";